import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { toast } from 'react-toastify';
import { Button } from 'rbx';

import client from '../../../utils/apolloClient';

const cleanTestOrdersQuery = gql`
  query cleanTestOrders {
    clean_test_orders(input: {}) {
      message
    }
  }
`;

const CleanTestOrders = () => {
  const [cleanTestOrders, { loading, data }] = useLazyQuery(
    cleanTestOrdersQuery,
    {
      client: client.clientPrivate,
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (data?.clean_test_orders?.message) {
      toast.success(data.clean_test_orders.message);
    }
  }, [data]);

  return (
    <Button
      color="primary"
      disabled={loading}
      onClick={() => cleanTestOrders()}
    >
      {loading ? 'Cleaning...' : 'Clean Test Orders'}
    </Button>
  );
};

export default CleanTestOrders;
